import {  
  DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS,
  ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS
} from '../../actions/types';


export const paginaAtualRelatorioItinerarios = (state = 1, action) => {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS: {
      return action.payload;
    }

    default:
      return state;
  }
};

export const registrosPorPaginaRelatorioItinerarios = (state = 50, action) => {
  switch (action.type) {
    case ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS: {
      return action.payload;
    }

    default:
      return state;
  }
};
